import dayjs from 'dayjs'

import Stack from '@mui/material/Stack'

import { toTitleCase } from '@shared/utils'

import Property from '@components/Details/Property'
import Section from '@components/Details/Section'

export default function DetailsSection({ assessment }) {
  const asyncAgeError = assessment.asyncAge <= 60

  return (
    <Section paper mini title="Details">
      <Property label="Status">{toTitleCase(assessment.status)}</Property>
      <Property label="Created">{dayjs(assessment.createdAt).format('L LT')}</Property>
      {assessment.dateReturned && <Property label="Answered">{dayjs(assessment.dateReturned).format('L LT')}</Property>}
      {assessment.lastCompletedLabDate && <Property label="Last Lab">{dayjs(assessment.lastCompletedLabDate).format('L LT')}</Property>}
      {assessment.asyncAge !== undefined && (
        <Property
          label="Async Age"
          sx={{
            value: {
              fontWeight: asyncAgeError ? 'bold' : undefined,
              color: asyncAgeError ? 'error.main' : undefined,
            },
          }}
        >
          {assessment.asyncAge}
        </Property>
      )}
    </Section>
  )
}

DetailsSection.Loading = function () {
  return (
    <Section paper mini title="Details">
      <Stack spacing={1} sx={{ py: 0.5 }}>
        <Property.Loading label="Status" />
        <Property.Loading label="Created" />
        <Property.Loading label="Answered" />
        <Property.Loading label="Last Lab" />
        <Property.Loading label="Async Age" />
      </Stack>
    </Section>
  )
}
